import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";



import classes from "../../components/Modal.module.css";

import Modal from "../../components/Modal";
import ErrorBox from "../../components/ErrorBox";
import ErrorMessage from "../../components/ErrorMessage";
import Loader from "../../components/Loader";
import CustomButton from "../../components/CustomButton";
import AddAnotherButton, { GENDER } from "../../components/AddAnotherButton";
import SectionDivider from "../../components/SectionDivider";
import CustomInput from "../../components/CustomInput";
import AreYouSureModal from "../../components/AreYouSureModal";

import useLanguage from "../../utils/useLanguage";
import { UserAuth } from "../../utils/AuthContext";
import Dropdown from "../../components/Dropdown";
import HotDropdown from "../../components/HotDropdown";

export default function AddBankModal({ showBankModal, setShowBankModal }) {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const { userData } = useContext(UserAuth);

  const [loadingModal, setLoadingModal] = useState(false);
  const [error, setError] = useState(false);
  const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);

  const [isAdmin, setIsAdmin] = useState(
    () =>
      localStorage.getItem("userType") === "superadmin" ||
      localStorage.getItem("userType") === "admin"
  );

  const [bank, setBank] = useState("");

  const [branches, setBranches] = useState([
    { branchName: "", branchAddress: "" },
  ]);

  const [selectedBankType, setSelectedBankType] = useState({
    title: t("iraqiBank"),
    value: true,
  });

  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState({
    title: t("chooseOrganization"),
    value: "",
  });

  const bankTypes = [
    { title: t("iraqiBank"), value: true },
    { title: t("foreignBank"), value: false },
  ];

  const spanStyles = currentDirection === "rtl" ? classes.shortSpan : null;

  const handleInputChange = (e, index = null) => {
    setError("");
    if (index === null) {
      setBank(e.target.value);
    } else {
      setBranches((prev) =>
        prev.map((branch, i) =>
          i === index ? { ...branch, [e.target.name]: e.target.value } : branch
        )
      );
    }
  };

  const handleAddBranch = () => {
    if (branches.length < 5) {
      setBranches([...branches, { branchName: "", branchAddress: "" }]);
    } else {
      setError("maxBranches");
    }
  };

  const fetchOrganizations = async (
    page = 1,
    limit = 5,
    _,
    searchQuery = ""
  ) => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/getOrganizations`,
        {
          params: {
            page,
            limit,
            search: searchQuery,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.status == 200) {
        setOrganizations(() =>
          res.data.organizations.map((org) => {
            return {
              title: org.organizationName,
              value: org.id,
            };
          })
        );
      }
    } catch (error) {}
  };

  const handleAddBank = async () => {
    const requiredFields = [
      bank,
      branches[0].branchName,
      branches[0].branchAddress,
    ];

    // Check for empty fields
    if (requiredFields.some((field) => !field)) {
      setError("emptyInputFields");
      return;
    }

    const organizationId = userData?.organizationId;

    try {
      setLoadingModal(true);
      const newBank = await axios.post(
        `${process.env.REACT_APP_URL}/api/bank`,
        {
          name: bank,
          branches,
          organizationId:
            isAdmin && selectedBankType.value
              ? null
              : parseInt(selectedOrganization?.value || organizationId),
          isIraqi: isAdmin ? selectedBankType.value : false,
        },
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );

      if (newBank.status === 201) {
        setShowBankModal(false);
        setBank("");
        setBranches([{ branchName: "", branchAddress: "" }]);
      } else {
        setError(t(newBank.message));
        console.error("Failed to create the bank", error);
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      setError(errorMessage || "Failed");
      console.error("Failed to create the bank", error);
    } finally {
      setLoadingModal(false);
    }
  };

  const handleCancel = () => {
    if (bank || branches.some((b) => b.branchName || b.branchAddress)) {
      setShowConfirmCancelModal(true);
    } else {
      setShowBankModal(false);
    }
  };

  const handleConfirmCancel = () => {
    setBank("");
    setBranches([{ branchName: "", branchAddress: "" }]);
    setShowBankModal(false);
    setShowConfirmCancelModal(false);
  };

  // SIDE EFFECTS
  useEffect(() => {
    fetchOrganizations();
  }, []);

  return (
    <>
      {!showConfirmCancelModal && (
        <Modal
          title="addBank"
          onClose={handleCancel}
          footer={
          <>
            {loadingModal ? <Loader /> : null}
            {error ? (
              <ErrorMessage classList="o-row o-row--horizontal-align_end">
                {t(error)}
              </ErrorMessage>
            ) : null}
            <section className={classes.actions}>
              <CustomButton
                onClick={handleAddBank}
                title={t("confirm")}
                icon="save"
                iconSize={16}
                disabled={loadingModal}
              />
              <CustomButton
                title={t("cancel")}
                onClick={handleCancel}
                icon="close"
                iconSize={15}
                variant="blank"
              />
            </section>
          </>
        }
      >
        <section>
          {error ? <ErrorBox>{t(error)}</ErrorBox> : null}

          <div className="o-column o-column--gap-size_300">
            {isAdmin && (
              <div className="o-column o-column--gap-size_300">
                <div className={classes.inputContainer}>
                  <span className={spanStyles}>{t("bankType")}:</span>
                  <Dropdown
                    options={bankTypes}
                    selected={selectedBankType}
                    setSelected={setSelectedBankType}
                    flex={true}
                  />
                </div>
                {!selectedBankType.value && (
                  <div className={classes.inputContainer}>
                    <span className={spanStyles}>{t("organization")}:</span>
                    {/* <Dropdown
                    options={organizations}
                    selected={selectedOrganization}
                    setSelected={setSelectedOrganization}
                    flex={true}
                  /> */}
                    <HotDropdown
                      initOptions={[...organizations]}
                      selected={selectedOrganization}
                      setSelected={setSelectedOrganization}
                      thick
                      flex
                      getData={fetchOrganizations}
                      optionsName={"organization"}
                    />
                  </div>
                )}
              </div>
            )}
            <div className={classes.inputContainer}>
              <span className={spanStyles}>{t("bankName")}:</span>
              <CustomInput
                name="bank"
                value={bank}
                onChange={(e) => handleInputChange(e, null)}
                errorText={error === "noBankName" ? t(error) : null}
                flex={true}
              />
            </div>
          </div>
          <SectionDivider title="branches" />
          {branches.map((branch, index) => (
            <div
              className={`${classes.flexableForm} ${
                index > 0 && "u-margin--top_700"
              }`}
              key={index}
            >
              <div className={classes.inputContainer}>
                <span className={spanStyles}>{t("branchName")}:</span>
                <CustomInput
                  name="branchName"
                  value={branch?.branchName}
                  onChange={(e) => handleInputChange(e, index)}
                  flex={true}
                />
              </div>
              <div className={classes.inputContainer}>
                <span className={spanStyles}>{t("branchAddress")}:</span>
                <CustomInput
                  name="branchAddress"
                  value={branch?.branchAddress}
                  onChange={(e) => handleInputChange(e, index)}
                  flex={true}
                />
              </div>
            </div>
          ))}

          <div className="u-margin--top_600 o-column o-column--vertical-align_end">
            <AddAnotherButton
              onClick={handleAddBranch}
              arrayLength={branches.length}
              title={t("addBranch")}
              gender={GENDER.MALE}
            />
          </div>
        </section>
        </Modal>
      )}
      {showConfirmCancelModal && (
        <AreYouSureModal
          shouldCloseModal={false}
          onClose={() => setShowConfirmCancelModal(false)}
          onConfirm={handleConfirmCancel}
          customMessage="areYouSureYouWantToCancel"
          closeTitle="noStay"
          confirmTitle="yesClose"
          confirm

        />
      )}
    </>
  );
}
